import { Link } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Nfc } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-2.5">
    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-900 text-white"><Nfc size={18} /></span>
    <span className="font-display text-lg font-bold tracking-tight">Identità<span className="text-blue-600">Impresa</span></span>
  </Link>
);

export const Navbar = () => (
  <header className="sticky top-0 z-50 border-b border-slate-200/60 bg-white/80 backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
      <Logo />
      <nav className="hidden items-center gap-8 text-sm font-medium text-slate-600 md:flex">
        <a href="#funzionalita" data-testid="nav-features-link" className="transition-colors hover:text-slate-900">Funzionalità</a>
        <a href="#come-funziona" data-testid="nav-how-link" className="transition-colors hover:text-slate-900">Come Funziona</a>
        <a href="#prova" data-testid="nav-demo-link" className="transition-colors hover:text-slate-900">Prova Live</a>
      </nav>
      <div className="flex items-center gap-2">
        <Show when="signed-out">
          <Button asChild variant="ghost" data-testid="nav-login-button"><Link to="/sign-in">Accedi</Link></Button>
          <Button asChild className="rounded-full bg-blue-600 hover:bg-blue-700" data-testid="nav-register-button"><Link to="/sign-up">Registrati</Link></Button>
        </Show>
        <Show when="signed-in">
          <Button asChild className="rounded-full bg-slate-900" data-testid="nav-dashboard-button"><Link to="/dashboard">La mia scheda</Link></Button>
          <UserButton />
        </Show>
      </div>
    </div>
  </header>
);
